import { useHistory } from "react-router-dom";
import Button from "../../uiComponents/Button/Button";
import { Stack } from "@mui/material";
import { gradients } from "../../Common/theme";
import { useAuth0 } from "@auth0/auth0-react";
import CONSTANTS from "../../Common/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

const SupportConfig = () => {
  let history = useHistory();
  const { loginWithRedirect } = useAuth0();

  return (
    <Stack
      sx={{
        background: gradients.dark,
        display: "flex",
        justifyContent: "center",
        position: "relative",
        pb: { xs: 10, sm: 20, md: 15, lg: 10 },
        height: "100vh",
        alignItems: "center",
      }}
    >
      <h1>
        ¡Registro
        <span className="primary"> COMPLETO!</span>
      </h1>
      <FontAwesomeIcon
        icon={faCircleCheck}
        className="primary"
        style={{ fontSize: 48, marginBottom: 30 }}
      />
      <p className="margin-v primary">Solo falta un paso mas:</p>

      <p className="margin-v">Tenemos que darte acceso a tu empresa. </p>
      <p className="margin-v">
        Solicitud alta cliente:{" "}
        <span className="primary">+54 9 11 6268-4825</span>
      </p>

      <p>
        <i className=" primary"></i>
        <span className="">
          Ventas: <span className="primary">+54 9 11 3107-3107</span>
        </span>
      </p>

      <p className="margin-v">Si ya te dieron acceso volvé a loguearte</p>
      <Stack
        direction="row"
        sx={{ width: "500px", maxWidth: "95vw", justifyContent: "center" }}
      >
        <Button
          label="Volver a loguearse"
          onClick={() => {
            loginWithRedirect();
          }}
          color="primary"
          center
        />
      </Stack>
    </Stack>
  );
};

export default SupportConfig;
